import { Controller } from "@hotwired/stimulus"
import { Datepicker } from "vanillajs-datepicker"
import { addMonths, endOfMonth, endOfYear } from 'date-fns'
import { datepickerText, datepickerOptions } from "@lib/utils"

Datepicker.locales.fr = datepickerText

// Connects to data-controller="datepicker"
export default class extends Controller {

  static targets = ["input"]
  
  static values = {
    min: { type: String, default: "" },
    max: { type: String, default: "" },
    format: { type: String, default: "dd/mm/yyyy" }
  }
  
  connect() {
    const minDate = this.minValue ? new Date(this.minValue) : null
    const maxDate = this.maxValue ? new Date(this.maxValue) : null
    const mergedOptions = Object.assign({}, datepickerOptions, { minDate, maxDate, language: 'fr', format: this.formatValue, showOnFocus: false, todayHighlight: true })
    this.picker = new Datepicker(this.inputTarget, mergedOptions)
  }

  submit() {
    this.element.closest("form")?.requestSubmit()
  }

  disconnect() {
    this.picker && this.picker.destroy()
  }

  clear() {
    this.picker.setDate({ clear: true })
  }

  today() {
    this.picker.setDate(new Date())
  }

  addMonths(event) {
    const months = parseInt(event.currentTarget.dataset.months)
    this.picker.setDate(addMonths(new Date(), months))
  }

  endOfMonth() {
    this.picker.setDate(endOfMonth(new Date()))
  }

  endOfYear() {
    this.picker.setDate(endOfYear(new Date()))
  }

}
